(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dn-sofa-steps"]) return;
  try {
    
(() => {
  const init = root => {
    root.querySelectorAll('[data-dn-steps]').forEach(section => {
      if (section.dataset.stepsReady) return;
      section.dataset.stepsReady = 'true';
      const choices = [...section.querySelectorAll('[data-dn-step-choice]')];
      const apply = (style, updateUrl) => {
        const choice = choices.find(input => input.value === style);
        if (!choice) return;
        if (choice.dataset.productUrl && location.pathname !== new URL(choice.dataset.productUrl,location.origin).pathname) {
          const destination = new URL(choice.dataset.productUrl,location.origin);
          const current = new URL(location.href);
          for (const [key,value] of current.searchParams) destination.searchParams.set(key,value);
          destination.searchParams.set('style',style);
          destination.searchParams.set('variant',choice.dataset.variantId);
          const blanketCheck = section.querySelector('[data-dn-bundle-check]');
          const blanketColour = section.querySelector('[data-dn-bundle-colour]');
          if (blanketCheck?.checked) destination.searchParams.set('blanket',blanketColour?.value || 'dark-grey');
          else destination.searchParams.delete('blanket');
          if(updateUrl) location.assign(destination.href); else location.replace(destination.href);
          return;
        }
        choice.checked = true;
        section.querySelector('[data-dn-steps-title]').textContent = choice.dataset.title;
        const stickyTitle = section.querySelector('[data-dn-steps-sticky-title]');
        if (stickyTitle) stickyTitle.textContent = choice.dataset.title;
        section.querySelectorAll('[data-dn-steps-gallery]').forEach(el => { el.hidden = el.dataset.dnStepsGallery !== style; });
        section.querySelectorAll('[data-dn-steps-detail]').forEach(el => { el.hidden = el.dataset.dnStepsDetail !== style; });
        section.querySelectorAll('[data-dn-steps-inside]').forEach(el => { el.hidden = el.dataset.dnStepsInside !== style; });
        section.querySelectorAll('[data-dn-steps-review]').forEach(el => { el.hidden = el.dataset.dnStepsReview !== style; });
        section.querySelector('[data-dn-price]').textContent = choice.dataset.price;
        const option = choice.closest('label');
        const priceRow = section.querySelector('.dn-story-price');
        ['data-dn-comparison-price', 'data-dn-comparison-saving'].forEach(attribute => {
          const source = option.querySelector('[' + attribute + ']');
          const target = priceRow.querySelector('[' + attribute + ']');
          if (source && target) target.textContent = source.textContent;
        });
        const add = section.querySelector('[data-dn-draft-add]');
        if (add) {
          add.dataset.dnDraftAdd = 'steps-' + style;
          add.dataset.title = choice.dataset.title;
          add.dataset.price = choice.dataset.price;
        }
        const nativeId=section.querySelector('[data-dn-native-id]');
        if (nativeId) {
          nativeId.value=choice.dataset.variantId || '';
          nativeId.dispatchEvent(new Event('change',{bubbles:true}));
          const available=choice.dataset.available==='true' && Boolean(nativeId.value);
          const submit=section.querySelector('[data-dn-native-submit]');
          submit.disabled=!available;
          submit.textContent=available?submit.dataset.addLabel:submit.dataset.soldLabel;
          section.querySelector('[data-dn-native-wallets]').hidden=!available;
        }
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.set('style', style);
          if(choice.dataset.variantId) url.searchParams.set('variant',choice.dataset.variantId);
          history.replaceState({}, '', url);
        }
      };
      choices.forEach(choice => choice.addEventListener('change', () => { if (choice.checked) apply(choice.value, true); }));
      const params = new URL(location.href).searchParams;
      const variantChoice = choices.find(choice => choice.dataset.variantId === params.get('variant'));
      const requested = variantChoice?.value || (params.get('variant') === '54247667761435' ? 'regular' : params.get('style'));
      apply(['regular', 'convertible'].includes(requested) ? requested : section.dataset.defaultStyle, false);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();


  } catch(e) { console.error(e); }
})();
})();
